import { v4 as uuidv4 } from 'uuid';
import { assignPublisherColors } from '../../../../commons/utils/publisherColors';
import { normalizePublicPublishers } from './normalizePublicPublisher';
import { getDiscoverPublishersAPI } from './api';
import staticIndustries from './data/directory-industries.json';

export const DIRECTORY_PAGE_LIMIT = 10;

// discover-publishers' own industry field is empty for some publishers that
// are also on the (already-capped top 25) What's Hot list, even though
// whats-hot's richer response has their real industries — same publisher,
// inconsistent backend data between the two endpoints. Backfill from
// whats-hot by pubId so the category filter doesn't lose these publishers.
function backfillWhatshotIndustries(publishers, whatshotPublishers) {
    if (!whatshotPublishers?.length) return publishers;
    const whatshotByPubId = new Map(whatshotPublishers.map((w) => [String(w.pubId), w]));
    return publishers.map((p) => {
        if (p.industries?.length) return p;
        const whatshotMatch = whatshotByPubId.get(String(p.pubId));
        if (!whatshotMatch?.industries?.length) return p;
        return { ...p, industries: whatshotMatch.industries };
    });
}

// Shared by both the initial page-1 fetch and loadMoreDirectoryPublishers so
// every page goes through the exact same normalize -> backfill -> color
// pipeline — a later page can't drift from how the first page looks.
export function preparePublisherData(rawPublishers, whatshotPublishers) {
    const normalized = normalizePublicPublishers(rawPublishers);
    const backfilled = backfillWhatshotIndustries(normalized, whatshotPublishers);
    return assignPublisherColors(backfilled);
}

// Recomputed against everything loaded so far (not just the latest page) so
// pagination never hides a pill for an industry that only shows up on a
// later page.
export function deriveDirectoryFilterIndustries(publishers) {
    if (!publishers.length) return staticIndustries;
    const publisherIndustries = new Set(publishers.flatMap((p) => p.industries || []));
    return staticIndustries.filter((i) => publisherIndustries.has(i));
}

async function getDirectoryPublishers() {
    this.observed.directoryPublishersLoading = true;
    try {
        const session = this.env.session;
        const traceId = this.env.traceId;
        this.directoryFilterIndustries = staticIndustries;
        this.observed.directoryPublishers = uuidv4();
        const res = await getDiscoverPublishersAPI({
            token: session?.token,
            traceId,
            page: 1,
            limit: DIRECTORY_PAGE_LIMIT,
        });
        const data = res?.data?.data || res?.data || null;
        const publishers = data?.publishers || [];
        const colored = preparePublisherData(publishers, this.whatshotPublishers);

        this.directoryFilterIndustries = deriveDirectoryFilterIndustries(colored);
        this.directoryPublishers = colored;
        this.directoryPage = 1;
        this.directoryHasMore = !!data?.hasNextPage;
        this.observed.directoryPublishers = uuidv4();
        this.applyDirectoryFilter();
    } finally {
        this.observed.directoryPublishersLoading = false;
    }
}

export default getDirectoryPublishers;
